import UserTrederoCustomKYC from './UserTrederoCustomKYC';

export default UserTrederoCustomKYC;
